module.exports = __webpack_public_path__ + "img/2.16f25084.png";